'use client'

import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'
import { Button } from './Button'

interface ModalProps {
  open: boolean
  title?: string
  description?: string
  children: ReactNode
  className?: string
  onClose: () => void
  footer?: ReactNode
}

export function Modal({ open, title, description, children, className, onClose, footer }: ModalProps) {
  if (!open) return null

  return (
    <div className="ui-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className={cn('ui-modal', className)}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={event => event.stopPropagation()}
      >
        <div className="ui-modal-header">
          <div>
            {title && <h2 className="card-title">{title}</h2>}
            {description && <p className="caption ui-modal-description">{description}</p>}
          </div>
          <Button variant="ghost" size="icon" aria-label="Close" onClick={onClose}>x</Button>
        </div>
        <div className="ui-modal-body">{children}</div>
        {footer && <div className="ui-modal-footer">{footer}</div>}
      </div>
    </div>
  )
}
